import type { Conversation, ErrorEvent, Message } from './chatTypes';

/** One locally retained backend conversation and its assembled display timeline. */
export type ConversationBranchSnapshot = {
  conversation: Conversation;
  displayMessages: Message[];
  errorEvents: ErrorEvent[];
  displayAncestorCount: number;
  parentConversationId: string | null;
  branchPointMessageId: string | null;
};

/** Session-only lineage for conversations created by editing a query. */
export type ConversationBranchSession = {
  rootConversationId: string | null;
  activeConversationId: string | null;
  conversationOrder: string[];
  branchesByConversationId: Record<string, ConversationBranchSnapshot>;
};

/** Payload used when a real backend conversation becomes a local branch. */
export type CreateConversationBranchPayload = {
  conversationId: string;
  createdAt: string;
  parentConversationId: string;
  branchPointMessageId: string;
  messages: Message[];
};

/** Creates a fresh branch session for initial state and chat resets. */
export const createEmptyConversationBranchSession =
  (): ConversationBranchSession => ({
    rootConversationId: null,
    activeConversationId: null,
    conversationOrder: [],
    branchesByConversationId: {},
  });
